import React from 'react';
import SearchIcon from '../SearchIcon';
import './style.less';

export const SearchCta = ({label, onClick, expandedSearchBox}) => (
    <div className={expandedSearchBox ? 'search__cta-container--hidden' : 'search__cta-container'}>
        <button className="search__cta" onClick={onClick}>
            <span className="search__cta-label">
                {label}
            </span>
            <span className="btn btn-primary search__cta-icon">
                <SearchIcon />
            </span>
        </button>
    </div>
);

export default SearchCta;
